(function(){
  // mobile drawer
  document.addEventListener('click', function(e){
    var op = e.target.closest('[data-ag-open]');
    var cl = e.target.closest('[data-ag-close]');
    var drawer = document.querySelector('[data-ag-drawer]');
    if(op && drawer){ drawer.classList.add('ag-open'); document.body.style.overflow='hidden'; }
    if((cl || e.target.matches('[data-ag-drawer] a')) && drawer){ drawer.classList.remove('ag-open'); document.body.style.overflow=''; }
  });

  // scroll reveal
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('ag-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.ag-reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.ag-reveal').forEach(function(el){ el.classList.add('ag-in'); });
  }

  // product qty steppers
  document.querySelectorAll('[data-qty-step]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var input = btn.parentNode.querySelector('input');
      var v = parseInt(input.value||'1',10) + parseInt(btn.getAttribute('data-qty-step'),10);
      if(v<1) v=1; input.value = v;
    });
  });

  // hero slideshow
  function initSlideshow(root){
    var slides = [].slice.call(root.querySelectorAll('.slide'));
    if(slides.length < 2) return;
    var dots = [].slice.call(root.querySelectorAll('.hero-dots .dot'));
    var i = 0, n = slides.length, timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var interval = (parseInt(root.getAttribute('data-interval'),10) || 6) * 1000;
    function show(k){
      i = (k + n) % n;
      slides.forEach(function(s,idx){ s.classList.toggle('is-active', idx===i); });
      dots.forEach(function(d,idx){ d.classList.toggle('is-active', idx===i); });
    }
    function next(){ show(i+1); }
    function prev(){ show(i-1); }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function play(){ if(autoplay){ stop(); timer = setInterval(next, interval); } }
    dots.forEach(function(d){ d.addEventListener('click', function(){ show(parseInt(d.getAttribute('data-go'),10)); play(); }); });
    var pv = root.querySelector('[data-hero-prev]'), nx = root.querySelector('[data-hero-next]');
    if(pv) pv.addEventListener('click', function(){ prev(); play(); });
    if(nx) nx.addEventListener('click', function(){ next(); play(); });
var canHover = window.matchMedia('(hover: hover)').matches;
    if(canHover) root.addEventListener('mouseenter', stop);
        if(canHover) root.addEventListener('mouseleave', play);
    play();
  }
  document.querySelectorAll('.hero-slideshow').forEach(initSlideshow);
})();
